import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Popover,
  List,
  ListItem,
  ListItemIcon,
  Checkbox, ListItemText, Typography,
  Tooltip, makeStyles
} from '@material-ui/core';

import { KeyboardArrowDown } from '@material-ui/icons';

const useStyles = makeStyles({
  listItemIcon: {
    minWidth: 'unset'
  },
  checkbox: {
    '&:hover': {
      background: 'transparent'
    }
  },
  listItemText: {
    paddingRight: 8,
    fontSize: 14
  }
}, { name: 'StatusFilter' });

const StatusFilter = ({
  type,
  statuses,
  statusFilters,
  handleStatusFilter,
  disabled
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [ anchor, setAnchor ] = useState(null);

  return (
    <>
      <Tooltip  title={ disabled ? t(`objective.filter.warning.developmentStatus`)  : '' } arrow>
        <div>
          <Button
            className={ `StatusFilter-${type}-button` }
            onClick={ e => setAnchor(e.currentTarget) }
            disabled={ disabled }
            startIcon={
              <Checkbox
                color="primary"
                checked={ !!statusFilters.length }
                disableRipple
                className={ classes.checkbox }
                disabled={ disabled }
              />
            }
            endIcon={ <KeyboardArrowDown /> }
          >
            <Typography className={ classes.listItemText }>
              {  t(`objective.filter.${type}`) }
            </Typography>
          </Button>
        </div>
      </Tooltip>
      <Popover
        open={ !!anchor }
        anchorEl={ anchor }
        onClose={ () => setAnchor(null) }
      >
        <List className='status-list'>
          {statuses.map(status => (
            <ListItem
              key={ status }
              onClick={ () => handleStatusFilter(status) }
              button
            >
              <ListItemIcon className={ classes.listItemIcon }>
                <Checkbox
                  color="primary"
                  checked={ statusFilters.includes(status) }
                  disableRipple
                  className={ classes.checkbox }
                  value={ status }
                />
              </ListItemIcon>
              <ListItemText className={ classes.listItemText }>
                {t(`objective.${type}.${status}`)}
              </ListItemText>
            </ListItem>
          ))}
        </List>
      </Popover>
    </>
  );
};

export default StatusFilter;
